const userLabel = require("../label/user");

const note_comment_like = {
  key: "note_comment_like",
  count_alias: "count_comment_likes_new",
  label_activity: "comment likes",
  label_data: "new comment like",
  label_detail: "A user likes a comment I've posted.",
  label_title: () => "New Comment Like",
  label_zero_state:
    "When a user likes a comment you've posted, we'll notify you here.",
  makeNote: (user) => userLabel(user) + " liked a comment you posted.",
  makeLink: ({ comment_id }) => `/comment/${comment_id}/likes`,
  table: "comment_like",
  leftJoins: ["comment", "user"],
  keys: [
    "comment_like.id AS id",
    "comment_like.created_at AS noted_at",
    "comment.id AS comment_id",
    "user.username AS username",
    "user.display_name AS display_name",
  ],
  wheres: ["comment.author_id = ?", "comment_like.user_id <> ?"],
  where_since: {
    index: 1,
    sql: "comment_like.created_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.id, user.id],
};

module.exports = note_comment_like;
